import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';

export default function FAQPage() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'Altın fiyatları nasıl belirleniyor?',
      answer: 'Altın fiyatları, uluslararası piyasalardaki anlık altın fiyatlarına göre belirlenmektedir. Fiyatlar günlük olarak güncellenmekte ve ödeme sırasında güncel fiyat üzerinden işlem yapılmaktadır.'
    },
    {
      question: 'Ürünler sertifikalı mı?',
      answer: 'Evet, tüm ürünlerimiz resmi sertifikalı ve garantilidir. Her ürünle birlikte sertifika ve garanti belgesi gönderilmektedir.'
    },
    {
      question: 'Kargo ücreti var mı?',
      answer: 'Hayır, tüm siparişlerinizde kargo ücretsiz ve sigortalıdır. Ürünleriniz güvenli bir şekilde adresinize teslim edilir.'
    },
    {
      question: 'İade koşulları nelerdir?',
      answer: 'Ürünü teslim aldıktan sonra 14 gün içinde iade edebilirsiniz. İade edilecek ürünün kullanılmamış ve orijinal ambalajında olması gerekmektedir.'
    },
    {
      question: 'Taksit imkanı var mı?',
      answer: 'Evet, tüm kredi kartlarına 12 aya varan taksit seçenekleri sunuyoruz. Ödeme sayfasında taksit seçeneklerini görebilirsiniz.'
    },
    {
      question: 'Mağazadan teslim alabilir miyim?',
      answer: 'Evet, siparişinizi Kapalıçarşı\'daki mağazamızdan ücretsiz olarak teslim alabilirsiniz. Sipariş verirken teslimat yöntemi olarak "Mağazadan Teslim" seçeneğini işaretlemeniz yeterlidir.'
    },
    {
      question: 'Ödeme güvenli mi?',
      answer: 'Evet, tüm ödemeler SSL ve 3D Secure ile korunmaktadır. Kredi kartı bilgileriniz güvenli bir şekilde işlenmekte ve saklanmamaktadır.'
    },
    {
      question: 'Sipariş takibi nasıl yapılır?',
      answer: 'Siparişiniz kargoya verildikten sonra e-posta adresinize kargo takip numarası gönderilir. Ayrıca hesabınızdaki "Siparişlerim" bölümünden de takip edebilirsiniz.'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 font-poppins">
      <Header />

      <div className="bg-gradient-to-r from-gold-50 to-amber-50 py-12">
        <div className="container mx-auto px-4">
          <nav className="text-sm text-gray-600 mb-4">
            <Link to="/" className="hover:text-gold-600 cursor-pointer">
              Anasayfa
            </Link>
            <span className="mx-2">/</span>
            <span className="text-gray-800 font-medium">Sıkça Sorulan Sorular</span>
          </nav>
          <h1 className="text-4xl font-bold text-gray-800 mb-3">Sıkça Sorulan Sorular</h1>
          <p className="text-gray-600">
            Merak ettiğiniz soruların cevaplarını burada bulabilirsiniz
          </p>
        </div>
      </div>

      <div className="container mx-auto px-4 py-12">
        <div className="max-w-3xl mx-auto">
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-white rounded-lg shadow-sm overflow-hidden">
                <button
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors cursor-pointer"
                >
                  <h3 className="font-semibold text-gray-800 pr-4">{faq.question}</h3>
                  <i
                    className={`ri-arrow-down-s-line text-2xl text-gold-600 transition-transform flex-shrink-0 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  ></i>
                </button>
                {openIndex === index && (
                  <div className="px-6 pb-6">
                    <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="bg-gradient-to-r from-gold-50 to-amber-50 rounded-lg p-8 mt-12 text-center">
            <h2 className="text-2xl font-bold text-gray-800 mb-3">
              Sorunuz mu var?
            </h2>
            <p className="text-gray-600 mb-6">
              Cevabını bulamadığınız sorular için bizimle iletişime geçebilirsiniz
            </p>
            <Link
              to="/iletisim"
              className="inline-block bg-gold-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-gold-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              İletişime Geç
            </Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
